import { all } from 'redux-saga/effects';

import { fetchQuotationsSaga } from './fetchQuotations';

export function* saga() {
    yield all([fetchQuotationsSaga()]);
}
